import { WellheadSectionBase } from './base/wellhead-section-base';

export class WellheadSection extends WellheadSectionBase { }